import { pixelGroups } from '@/config/pixelConfig'

/** ********************************************************
 * 工具：讀取 Cookie
 **********************************************************/
function getCookie(name) {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='))
    ?.split('=')[1] || null
}

function sendGroupEvents(group, mainEventName) {
  if (!window.fbq) return

  group.forEach((item, index) => {
    setTimeout(() => {
      window.fbq('trackSingle', item.pixel, item.event)
      console.log(`[Pixel] [` + mainEventName + `]Group Event → pixel=${item.pixel}, event=${item.event}`)
    }, index * 150)
  })
}

function triggerEvent(mainEventName, purchaseValue = null) {
  const btag = decodeURIComponent(getCookie('ad_source_btag') || '')
  const group = pixelGroups[btag]

  if (group) {
    // 有匹配 → 群組 TEST 事件
    sendGroupEvents(group, mainEventName)
    return
  }

  // 未匹配（自然流量）→ 只送預設事件
  if (mainEventName === 'Purchase') {
    // Purchase 需要 value & currency
    window.fbq('track', 'Purchase', {
      value: purchaseValue || 0, // ← 至少填 0，否則會報錯
      currency: 'JPY'
    })
    console.log(`[Pixel] Default Purchase → value=${purchaseValue || 0}`)
  } else {
    // 註冊不需要參數
    window.fbq('track', mainEventName)
    console.log(`[Pixel] Default Event → ${mainEventName}`)
  }
}

export function sendRegisterEvent() {
  triggerEvent('CompleteRegistration')
}

export function sendFirstPurchaseEvent() {
  triggerEvent('Purchase')
}
